import { render, staticRenderFns } from "./provider.vue?vue&type=template&id=0e73ece0&scoped=true&"
import script from "./provider.vue?vue&type=script&lang=js&"
export * from "./provider.vue?vue&type=script&lang=js&"
import style0 from "./provider.vue?vue&type=style&index=0&id=0e73ece0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e73ece0",
  null
  
)

export default component.exports